<div class="stick-top">
  <mat-toolbar>
    <mat-icon>message</mat-icon> USSD Sessions
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <micro-checkbox [(checked)]="settings.autoRefresh" (checkedChange)="saveSettings()" negative="Auto-Refresh" positive="Auto-Refreshing"></micro-checkbox>&nbsp;
    <button mat-raised-button class="primary" type="button" (click)="reload()">
      <mat-icon>refresh</mat-icon>
      Refresh now
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th style="width: 172px;">
        <div class="vbox">
          Started
        </div>
      </th>
      <th>
        <div class="vbox">
          Svc.Code
          <micro-ussdSvcCode-select [(ussdSvcCodeId)]="filter.ussdSvcCodeId"></micro-ussdSvcCode-select>
        </div>
      </th>
      <th style="width: 86px;">
        <div class="vbox">
          Msisdn
          <input [(ngModel)]="filter.msisdn">
        </div>
      </th>
      <th>
        <div class="vbox">
          MNO
          <micro-mno-select [(mnoId)]="filter.mnoId"></micro-mno-select>
        </div>
      </th>
      <th style="width: 70px;">
        <div class="vbox">
          Status
          <select  [(ngModel)]="filter.status">
            <option value="">ALL</option>
            <option value="START">START</option>
            <option value="CONTINUE">CONTINUE</option>
            <option value="END">END</option>
          </select>
        </div>
      </th>
      <th style="width: 172px;">
        <div class="vbox">
          Last Updated
        </div>
      </th>
      <th>
        <div class="vbox">
          Carrier
          <micro-ussdCarrier-select [(ussdCarrierId)]="filter.ussdCarrierId"></micro-ussdCarrier-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          TrackingId
          <input [(ngModel)]="filter.trackingId">
        </div>
      </th>

      <th>
        <div class="vbox">
          Error
          <input [(ngModel)]="filter.error">
        </div>
      </th>
      <th>
        <div class="vbox">
          Error.Detail
          <input [(ngModel)]="filter.errorDetail">
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td [ngClass]="element.error ? 'CRITICAL' : ''" [matTooltip]="element.errorDetail ? element.errorDetail : ''"><a routerLink="/ussdSessions/{{element.id}}">{{element.createdDate|dateTimeMs}}</a></td>
      <td><micro-ussdSvcCode-lookup [ussdSvcCodeId]="element.ussdSvcCodeId"></micro-ussdSvcCode-lookup></td>
      <td>{{element.msisdn}}</td>
      <td><micro-mno-lookup [mnoId]="element.mnoId"></micro-mno-lookup></td>
      <td>{{element.status}}</td>
      <td>{{element.modifiedDate|dateTimeMs}}</td>
      <td><micro-ussdCarrier-lookup [ussdCarrierId]="element.ussdCarrierId"></micro-ussdCarrier-lookup></td>
      <td>{{element.trackingId}}</td>
      <td>{{element.error}}</td>
      <td>{{element.errorDetail}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
